// extracted by mini-css-extract-plugin
export default {"body":"hqmuXAPQhu6gBAooiG5p"};